<template>
    <div class="">
        <!-- 头部导航 -->
		
        <div class="headers-container bg-theme " :style="'background-color:' +bg+ ';color:'+color+';'">
			<div v-if="data_completed==null&&userInfo&&(userInfo.teacher_id&&(userInfo.teacher_staus=='1'))" class="first_teacher_login flex alcenter center">
				<div class="ftr-1-25">
					完成設置老師帳戶，便可申請開始教學！
				</div>
				<div class="btn ml30" @click="data_completed=true;toTeacher(true);">去完成</div>
			</div>
            <div class="" style="padding: 0 2rem;">
            	<header class="d-flex align-items-center justify-content-between pt-3 pb-3">
            	    <div class="d-flex align-items-center justify-content-center">
            			<img :src="webLogo" alt="" v-if="bg != '#000'" />
            	        <div class="ftr-1-5 ftw600 font-family-e clickAct" @click="toHome">
            	            {{$t('common.webName')}}
            	        </div>
            	        <ul class="nav mb-2 justify-content-center mb-md-0 ms-sm-3 d-lg-flex d-none">
            	            <li class="ft-125 ftw600 px-2 clickAct" @click="toSearch">
            					<!-- 搜索教師 -->
            					 {{$t('headers.searchTeachers')}}
            				</li>
            				<!-- 推介老師 -->
            	           <!-- <li class="ft-125 ftw600 px-2 clickAct" @click="showTeacher = true">
            					
            					{{$t('headers.recommendTeachers')}}
            				</li> -->
            				<li class="ft-125 ftw600 px-2 clickAct" @click="toTeacher"   v-if="userInfo&&(userInfo.teacher_id&&(userInfo.teacher_staus=='1'))">
            					<!-- 老師入口 -->
            					{{$t('headers.teacherPortal')}}
            				</li>
            				<!--   -->
            	            <li class="ft-125 ftw600 px-2 clickAct" v-else @click="toBecomeTeacher" >
            					<!-- 成爲老師 -->
            					{{$t('headers.becomeTeacher')}}
            				</li>
            				<!-- -->
            				
            	        </ul>
            	    </div>
            	
            	    <div class=" d-flex text-end align-items-center d-md-flex d-none" >
						<div class="flex alcenter"  v-if="userInfo&&(userInfo.teacher_id&&(userInfo.teacher_staus=='1'))">
							<a-switch v-model:checked="webPatternTab" @change="changePattern" class="mr10"/>
							<div style="border: 1px solid #000;padding: 6px 12px;border-radius: 4px;" >{{webPatternTab?$t('common.patternStudent'):$t('common.patternTeacher')}}</div>
						</div>
						
						
            	        <select class="form-select clickAct" aria-label="Default select example" :style="'color:'+color+';'"
            			v-model="selectedLanguage">
            	           <option :value="item.value" v-for="(item,index) in language"
            				:style="color=='#fff' ? 'color: #000;':''"
            				>{{item.name}}</option>
            	        </select>
            			
            	        <select class="form-select clickAct" v-model="selectedCurrency" aria-label="Default select example"
            			style="width: 100px;"
            			 :style="'color:'+color+';'">
            	            <option :value="item.currency" v-for="(item,index) in currency"
            	            :style="color=='#fff' ? 'color: #000;':''"
            	            >{{item.currency}}</option>
            	        </select>
						<!-- 消息通知 -->
						<a-dropdown @visibleChange="visibleChange">
						    <a-icon type="bell" class="ft20 mr20"  />
						    <template #overlay>
						      <a-menu>
								  <a-menu-item>
								  	<div class="">
								  		通知
								  	</div>
								  </a-menu-item>
						        <a-menu-item v-for="(item,index) in messageList">
									<!-- 课堂确认 -->
								  <div class="flex" v-if="item.type == 1" @click="toPage('/students?index=1')">
									  <img src="../assets/image/header_icon1.png" alt="" class="header-icon" style="" />
									  <div>
										  <div class="ft16">我的課堂</div>
										  <div class="ft14">你有一個課堂預約未確認</div>
										  <div class="ft14">{{item.updatetime}}</div>
									  </div>
									  <div class="header-dot"></div>
								  </div>
								  <!-- 附录查看 作业 -->
								  <div class="flex" v-if="item.type == 2" @click="toPage('/students?index=3')">
								  	<img src="../assets/image/header_icon2.png" alt="" class="header-icon" />
								  	<div>
								  		<div class="ft16"> 我的作業</div>
								  		<div class="ft14">老師剛上傳了一份作業</div>
								  		<div class="ft14">{{item.updatetime}}</div>
								  	</div>
									<div class="header-dot"></div>
																  
								  </div>
								  <!-- 学习报告 -->
								  <div class="flex" v-if="item.type == 3" @click="toPage('/students?index=5')">
								  	<img src="../assets/image/header_icon3.png" alt="" class="header-icon" />
								  	<div>
								  		<div class="ft16">學習報告</div>
								  		<div class="ft14">老師給你了一份學習報告</div>
								  		<div class="ft14">{{item.updatetime}}</div>
								  	</div>
									<div class="header-dot"></div>							  
								  </div>
						        </a-menu-item>
						        <a-menu-item>
									<div class="text-center" @click="toPage('/message')">
										查看全部
									</div>
								</a-menu-item>
						      </a-menu>
						    </template>
						  </a-dropdown>
						
						<!-- 讯息 -->
						<a-dropdown @visibleChange="visibleChange1">
						    <a-icon type="message" class="ft20 mr20"  />
						    <template #overlay>
						      <a-menu>
								  <a-menu-item>
								  	<div class="">
								  		訊息
								  	</div>
								  </a-menu-item>
						        
						       <a-menu-item v-for="(item,index) in fastimList">
						         <div class="flex" style="max-width: 300px;"  @click="openKefu(item.sender_id)">
						       	  <img :src="item.avatar" alt="" class="header-icon" style="" />
						       	  <div>
						       		  <div class="ft16">{{item.nickname}}</div>
						       		  <div class="ft14 text-over" style="width: 240px;">{{item.message}}</div>
						       		  <div class="ft14">{{formatTimestamp(item.createtime) }}</div>
						       	  </div>
						       	  <div class="header-dot"></div>
						         </div>
						       </a-menu-item>
							   <a-menu-item>
							   	<div class="text-center" @click="toPage('/message')">
							   		查看全部
							   	</div>
							   </a-menu-item>
						      </a-menu>
						    </template>
						  </a-dropdown>
						
            			<a-icon type="question-circle" class="ft20 mr20"  @click="toQuestion"/>
            			<div class="d-flex align-items-center clickAct" v-if="checkLogin()"  @click="toStudents"> 
            				<!-- <div class="ftr-1 ftw900" v-if="userInfo&&userInfo.money">
            					Mira Coins{{$t('common.balance')}}： 
            					<span class="cl-red">{{selectedCurrency}} {{convertCurrency( Number(userInfo.money),rate)}}</span>
            				</div> -->
            				
            				<a-dropdown>
            				    <img :src="userInfo.avatar" alt="" class="header-login"  v-if="userInfo&&userInfo.avatar" />
            				    <img src="../assets/image/woyaoyou_head_defult@2x.png" alt="" class="header-login" v-else />
            				    <template #overlay>
            				      <a-menu>
            				        <a-menu-item>
            				          <div class="ftr-1 ftw900" >
										{{userInfo.nickname}}
            				          </div>
									  <div class="cl-theme mt-2" v-if="userInfo&&userInfo.money">
										 Mira Coins{{$t('common.balance')}}：  {{selectedCurrency}} {{convertCurrency( Number(userInfo.money),rate)}}
									  </div>
            				        </a-menu-item>
            				        <a-menu-item>
										<div @click="toPage('/students?index=0')">
											{{$t('common.homePage')}}
										</div>
            				        </a-menu-item>
            				        <a-menu-item>
										<div @click="toPage('/students?index=1')">
											{{$t('teacherVue.myClass')}}
										</div>
            				        </a-menu-item>
									<a-menu-item>
										<div @click="toPage('/students?index=6')">
											{{$t('studentsCom.myTeacher')}}
										</div>
									</a-menu-item>
									<a-menu-item>
										<div @click="toPage('/students?index=7')">
											{{$t('common.myWalletuser')}}
										</div>
									</a-menu-item>
									<a-menu-item>
										<div @click="toPage('/students?index=8')">
											{{$t('common.transactionRecords')}}
										</div>
									</a-menu-item>
									<a-menu-item>
										<div @click="toPage('/students?index=9')">
											{{$t('common.setting')}}
										</div>
									</a-menu-item>
									<a-menu-item>
										<div style="border-top: 1px solid #5b5b5b;padding-top: 10px;" @click="logOut">
											{{$t('common.logoutUser')}}
										</div>
									</a-menu-item>
            				      </a-menu>
            				    </template>
            				  </a-dropdown>
            			</div>
            			<div class="" v-else>
            				<button type="button" class="btn btn-outline-dark  ms-sm-3 d-flex align-items-center ftw600"
            				    style="border: 2px solid #000;" @click="toLogin" :style="'color:'+color+';border: 2px solid'+color">
            				    {{$t('common.login')}}
            				    <img src="../assets/image/index/index-black.png" alt="" v-if="color=='#000'"
            				        style="width: 18px;height: 18px;margin-left: 4px;" />
            					<img src="../assets/image/index/index-black-w.png" alt="" v-else
            					    style="width: 18px;height: 18px;margin-left: 4px;" />
            				</button>
            			</div>
            	    </div>
            	    <!-- 手机端按钮 -->
            	    <button v-if="isMobile" type="button" class="btn btn-outline-dark d-lg-none"
            	        @click="showMobileMenu = true" :style="'color:'+color+';'">
            	        ☰
            	    </button>
            	</header>
            </div>
			
        </div>
        <div style="height: 72px;background-color: #40ccd8;" ></div>
		<div class="line"></div>
        <!-- 右侧弹出菜单 -->
        <div v-if="showMobileMenu" class="mobile-menu-overlay" @click.self="showMobileMenu = false">
            <div class="mobile-menu-content show">
				<div class="flex alcenter" v-if="checkLogin()" @click="toStudents()" >
					<img :src="userInfo.avatar" alt="" class="header-login" style="margin-left: 0 !important;" v-if="userInfo&&userInfo.avatar" />
					<img src="../assets/image/woyaoyou_head_defult@2x.png" alt="" style="margin-left: 0 !important;" class="header-login" v-else />
					<div class="ml10">
						{{userInfo.nickname}}
					</div>
				</div>
				<div class="ftr-1 mt-2" v-if="checkLogin()">
					Mira Coins{{$t('common.balance')}}： <span class="cl-red">{{selectedCurrency}}$ {{convertCurrency(2500,0.137)}}</span>
				</div>
				<div class="flex alcenter mt-3" @click="toSearch">
					<a-icon type="search" class="mr10"></a-icon>
					{{$t('headers.searchTeachers')}}
				</div>
				<!-- <div class="flex alcenter mt-2" @click="showTeacher = true">
					<a-icon type="dollar" class="mr10"></a-icon>
					 {{$t('headers.recommendTeachers')}} 
				</div>-->
				
				
				<div class="flex alcenter mt-2" @click="toTeacher"  v-if="userInfo&&(!userInfo.teacher_id||userInfo.teacher_status!=1)">
					<a-icon type="user" class="mr10"></a-icon>
					{{$t('headers.teacherPortal')}}
				</div>
				<div class="flex alcenter mt-2" @click="toBecomeTeacher" v-else>
					<a-icon type="user" class="mr10"></a-icon>
					{{$t('headers.becomeTeacher')}}
				</div>
				<div class="flex alcenter mt-2" @click="">
					<a-icon type="question-circle" class="mr10"></a-icon>
					 {{$t('common.askedQuestions')}} 
				</div>
               <select class="form-select border-gray mt-2" aria-label="Default select example"
			   style="font-weight: 400;padding: 10px 0 !important; text-align: center;width: 100%;" v-model="selectedLanguage">
				  <option :value="item.value" v-for="(item,index) in language" class="cl-black"
				   >{{item.name}}</option>
				  <!-- <option value="simplified_chinese" :style="color=='#fff' ? 'color: #000;':''">简体中文</option>
				   <option value="traditional_chinese" :style="color=='#fff' ? 'color: #000;':''">繁体中文</option>
				   <option value="english" :style="color=='#fff' ? 'color: #000;':''">英语</option>
				   <option value="JA" :style="color=='#fff' ? 'color: #000;':''">日语</option>
				   <option value="KO" :style="color=='#fff' ? 'color: #000;':''">韩语</option> -->
               </select>
               <select class="form-select border-gray mt-2" aria-label="Default select example" 
			   style="font-weight: 400;padding: 10px 0 !important; text-align: center;width: 100%;"
			   v-model="selectedCurrency">
				   <option class="cl-black" :value="item.currency" v-for="(item,index) in currency"
				   >{{item.currency}}</option>
                  
               </select>
			   
                <button type="button" v-if="!checkLogin()"
				class="btn btn-outline-dark mt-3  ms-sm-3 d-flex justify-content-center align-items-center"
				 @click="toLogin">
                     {{$t('common.login')}}
                    <img src="../assets/image/index/index-black.png" alt=""
                        style="width: 18px;height: 18px;margin-left: 4px;" />
                </button>
				<button type="button" v-else
				class="btn btn-outline-dark mt-3  ms-sm-3 d-flex justify-content-center align-items-center"
				 @click="logOut">
				     {{ $t('userMySetting.logOut') }}
				    <img src="../assets/image/index/index-black.png" alt=""
				        style="width: 18px;height: 18px;margin-left: 4px;" />
				</button>
            </div>
        </div>
		
		<!-- 介绍老师 -->
		<div class="" v-if="showTeacher">
			<introduction-teacher :visible="showTeacher" @cancel="showTeacher = false"></introduction-teacher>
		</div>
    </div>
</template>

<script>
import introductionTeacher from '../components/teacher/introductionTeacher.vue'
export default {
	components: {
		introductionTeacher
	},
	props:{
		bg:{
			type:String,
			default:'#52C4C9'
		},
		color:{
			type:String,
			default:'#000'
		}
	},
    data() {
        return {
			selectedLanguage:localStorage.getItem('language')?localStorage.getItem('language'):'Cantonese',
			selectedCurrency:localStorage.getItem('currency')?localStorage.getItem('currency'):'HK$',
            showMobileMenu: false,
            isMobile: false,
			showTeacher:false,
			language:[],
			currency:[],
			rate:1,//汇率
			webLogo:localStorage.getItem('webLogo'),
			data_completed:localStorage.getItem('data_completed'),
			webPattern:'student',
			webPatternTab:true,
			messageList:[],
			fastimList:[]
        };
    },
	watch: {
	        // 监听语言选择变化
	        selectedLanguage(newValue) { 
	            console.log('选中的语言: ', newValue);
	            // 这里可以添加处理语言切换的逻辑
				localStorage.setItem('language',this.selectedLanguage)
				if(this.selectedLanguage=='simplified_chinese'){
					 this.$i18n.locale='zh-Hant'
				}else if(this.selectedLanguage=='traditional_chinese'|| this.selectedLanguage=='Cantonese'){
					this.$i18n.locale='zh-Hans'
				}else if(this.selectedLanguage=='english'){
					this.$i18n.locale='en'
				}else if(this.selectedLanguage=='JA'){
					this.$i18n.locale='JA'
				}else if(this.selectedLanguage=='KO'){
					this.$i18n.locale='KO'
				}else{
					this.$i18n.locale='zh-Hans'
				}
				localStorage.setItem('language',newValue)
				 window.location.reload();
				this.$router.push('/');
				//
	        },
	        // 监听货币选择变化
	        selectedCurrency(newValue) { 
	            console.log('选中的货币: ', newValue);
	            // 这里可以添加处理货币切换的逻辑
				this.realRate()
				localStorage.setItem('currency',newValue)
	        }
	    },
    created() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
		this.informationIntegration()
		this.selectedCurrency = localStorage.getItem('currency')?localStorage.getItem('currency'):''
		if(this.selectedLanguage=='simplified_chinese'){
			 this.$i18n.locale='zh-Hant'
		}else if(this.selectedLanguage=='traditional_chinese' || this.selectedLanguage=='Cantonese'){
			this.$i18n.locale='zh-Hans'
		}else if(this.selectedLanguage=='english'){
			this.$i18n.locale='en'
		}else if(this.selectedLanguage=='JA'){
			this.$i18n.locale='JA'
		}else if(this.selectedLanguage=='KO'){
			this.$i18n.locale='KO'
		}else{
			this.$i18n.locale='zh-Hans'
		}
		console.log("this.userInfo",this.userInfo);
		
		localStorage.getItem('webPattern')?this.webPattern = localStorage.getItem('webPattern'):this.webPattern ='student'
		this.webPattern == 'student'?this.webPatternTab = true:this.webPatternTab = false
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
		formatTimestamp(timestamp) {
		  // 转换为毫秒级时间戳
		  const date = new Date(timestamp * 1000);
		  
		  const year = date.getFullYear();
		  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
		  const day = String(date.getDate()).padStart(2, '0');
		  const hours = String(date.getHours()).padStart(2, '0');
		  const minutes = String(date.getMinutes()).padStart(2, '0');
		  const seconds = String(date.getSeconds()).padStart(2, '0');
		  
		  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
		visibleChange(e){
			if(e){
				this.getUserMessageList()
			}
		},
		visibleChange1(e){
			if(e){
				this.getFastimMessage()
			}
		},
		toPage(path){
			this.$router.push(path)
		},
		changePattern(){
			console.log(this.webPattern);
			
			this.webPatternTab?this.webPattern = 'student':this.webPattern = 'teacher'
			localStorage.setItem('webPattern', this.webPattern)
			if(this.webPattern == 'student'){
				this.$router.push('/');
			}else{
				this.$router.push('/teacherIndex');
			}
		},
		logOut() {
		    this.$confirm({
		        title: this.$t('userMySetting.confirmLogout'),
		        content: this.$t('userMySetting.logoutContent'),
		        okText: this.$t('common.confirm'),
		        okType: "danger",
		        cancelText: this.$t('common.cancel'),
				okButtonProps: {
				    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
				  },
		        onOk: () => {
		            localStorage.setItem('account-token', null)
					this.updateUserInfo(null)
					this.updateTeacherInfo(null)
		            this.$router.push('/login')
		        },
		        onCancel: () => {
		            console.log("Cancel");
		        },
		    });
		},
		getFastimMessage(){
			this.$http.api('plugin/fastim/messageList',{
				// status:0,//状态:0=未读,1=已读,2=发送中,3=隐藏状态,4=失败
				page:1,
				limit:3,
			}).then(res=>{
				this.fastimList = res.list
			})
		},
		
		// 获取消息,系统内部
		getUserMessageList(){
			this.$http.api('user/userMessageList',{
				page:1,
				limit:3
			}).then(res=>{
				this.messageList = res.list
			})
		},
		// 获取汇率
		realRate(){
			this.$http.api('common/realRate',{
				currency:'CNY'
			}).then(res=>{
				if(this.selectedCurrency!=='CNY'){
					this.rate = Number(res.result.list[this.selectedCurrency].rate)
				}else{
					this.rate = 1
				}
				localStorage.setItem('rate',this.rate)
			})
		},
		informationIntegration(){
			this.$http.api('information/informationIntegration',{
				type:[ "systemLanguage","currency",]
			}).then(res=>{
				this.language = res.list.systemLanguage.list
				this.currency = res.list.currency.list
				// this.selectedLanguage = localStorage.getItem('language')?localStorage.getItem('language'): ''
				this.selectedCurrency =  localStorage.getItem('currency')?localStorage.getItem('currency'): 'HK$'
			})
		},
		
		toSearch(){
			// this.$router.push('/classIndex');
			this.$router.push('/forStudy');
		},
		toQuestion(){
			this.$router.push('/problem');
		},
		toHome(){
			this.$router.push('/');
		},
        toLogin() {
            this.$router.push('/login');
            this.showMobileMenu = false;
        },
		toStudents(){
			this.$router.push('/students');
		},
		toBecomeTeacher(){
			if(!this.checkLogin()){
				this.$router.push('/login');
				return
			}
			if(this.userInfo.teacher_staus=='2'){
				this.$message.info('审核中，请等待审核')
				return
			}
			this.$router.push('/beforeBecomeTeacher');
		},
		toTeacher(boo){
			if(boo){
				localStorage.setItem('data_completed',false)
			}
			this.$router.push('/teacherIndex');
		},
        checkMobile() {
            this.isMobile = window.innerWidth < 992;
        }
    }
};
</script>

<style lang="less" scoped>
	.header-icon{
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-right: 10px;
	}
	.header-dot{
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: #ea5346;
		margin-left: 50px;
		margin-top: 20px;
	}
	.ant-switch-checked{
		background-color: #000;
	}
	.first_teacher_login{
		background-color: #FFB42C;
		height: 50px;
		width: 100%;
		position: relative;
		left: 0;
		right: 0;
		.btn{
			width: 120px;
			height: 40px;
			color: #fff;
			font-size: 16px;
			border-radius: 20px;
			text-align: center;
			// line-height: 40px;
			background-color: #674EA7;
		}
	}
	.ft-125{
		font-size: 1rem !important;
	}
	.header-login{
		width: 40px;
		height: 40px;
		border-radius: 8px;
		margin-left: 16px;
	}
    .mobile-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }

    .mobile-menu-content {
        position: fixed;
        top: 0;
        right: -300px;
        /* 初始隐藏在右侧 */
        width: 300px;
        height: 100%;
        background-color: white;
        padding: 20px;
        display: flex;
        flex-direction: column;
        transition: right 0.3s ease;
    }

    .mobile-menu-content.show {
        right: 0;
        /* 显示菜单 */
    }

    .mobile-menu-overlay.show .mobile-menu-content {
        right: 0;
    }

    .form-select {
        background-color: transparent;
        border: none;
        background-image: none;
        width: fit-content;
        font-weight: 600;
		width: fit-content;
		font-size: 1rem;
		padding: 0 1rem !important;
    }

    .form-select:focus {
        outline: none;
        box-shadow: none;
    }
	.headers-container {
		margin: 0;
		max-width: 100%;
		// padding: 0 2rem;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 8;
	}
</style>